import { Action } from '@ngrx/store';

import * as authActions from '@auth/store/auth.actions';

import { ListEntry } from './../list-entry';

export const API_PRELOAD_LISTS = '[API] - Preload Lists';
export const API_REQUEST_LIST = '[API] - Request List';
export const API_STORE_LIST = '[API] - Store List';

export const API_STORE_ERROR_REPORT = '[API] - Store Error Report';

export const API_PRELOAD_CUST_LISTS = '[API] - Preload Customer Lists';
export const API_CLEAR_CUST_LISTS = '[API] - Clear Customer Lists';
export const API_REQUEST_CUST_LIST = '[API] - Request Customer List';
export const API_STORE_CUST_LIST = '[API] - Store Customer List';

export class ApiPreloadLists implements Action {
  readonly type = API_PRELOAD_LISTS;
}

export class ApiRequestList implements Action {
  readonly type = API_REQUEST_LIST;
  constructor(public list: string) {}
}

export class ApiStoreList implements Action {
  readonly type = API_STORE_LIST;
  constructor(public listEntry: ListEntry) {}
}

export class ApiStoreErrorReport implements Action {
  readonly type = API_STORE_ERROR_REPORT;
  constructor(public payload: any) {}
}

export class ApiPreloadCustomerLists implements Action {
  readonly type = API_PRELOAD_CUST_LISTS;
}

export class ApiRequestCustomerList implements Action {
  readonly type = API_REQUEST_CUST_LIST;
  constructor(public list: string) {}
}

export class ApiStoreCustomerList implements Action {
  readonly type = API_STORE_CUST_LIST;
  constructor(public listEntry: ListEntry) {}
}

export class ApiClearCustomerLists implements Action {
  readonly type = API_CLEAR_CUST_LISTS;
}

export type DataActions =
  | ApiPreloadLists
  | ApiRequestList
  | ApiStoreList
  | ApiStoreErrorReport
  | ApiPreloadCustomerLists
  | ApiRequestCustomerList
  | ApiStoreCustomerList
  | ApiClearCustomerLists
  | authActions.ChangeCustomer
  | authActions.ChangeFacility;
